import { MapData } from '@project/store/LinkController/types';

export const validationMapParams = (data: MapData) => {
  const zoom = +data.zoom;
  const center = data.center.split(',').map(Number);
  if (!validationZoom(zoom)) return undefined;
  if (!validationCenter(center)) return undefined;

  return {
    zoom: zoom,
    center: center,
    layersName: data.layersName?.split(',') ?? [],
  };
};

export const validationZoom = (zoom: number) => {
  if (zoom > 20 && zoom < 1) return false;
  if (isNaN(zoom)) return false;

  return true;
};

export const validationCenter = (center: number[]) => {
  if (!center[0] || !center[1]) return false;
  if (isNaN(center[0]) || isNaN(center[1])) return false;

  return true;
};
